/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { useIntl } from 'react-intl';

import { cssMap, jsx } from '@atlaskit/css';
import { Box, Stack } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { messages } from './messages';
import type { UnitSwitcherProps } from './types';
import { UnitSwitcherItem } from './unit-switcher-item';
import type { UnitSwitcherItemProps } from './unit-switcher-item/types';

const styles = cssMap({
	divider: {
		borderBottomWidth: token('border.width'),
		borderBottomStyle: 'solid',
		borderBottomColor: token('color.border'),
		marginTop: token('space.200'),
		marginBottom: token('space.200'),
	},
	unitHeader: {
		font: token('font.body.small'),
		color: token('color.text.subtlest'),
		paddingBlock: token('space.100'),
		paddingInline: token('space.100'),
		fontWeight: token('font.weight.medium'),
	},
});

const UnitSwitcher = (props: UnitSwitcherProps): JSX.Element => {
	const { formatMessage } = useIntl();
	return (
		<Stack>
			<Box>
				<Box xcss={styles.divider} />
				<Box xcss={styles.unitHeader}>
					{formatMessage(messages.unitHeader, { orgName: props.orgName })}
				</Box>
				<Stack space="space.050">
					{props.units.map((unit: UnitSwitcherItemProps) => (
						<UnitSwitcherItem
							id={unit.id}
							key={unit.id}
							name={unit.name}
							isSelectedUnit={props.selectedUnitId === unit.id}
							onClick={() => {
								props.setSelectedUnit(unit.id);
							}}
						/>
					))}
				</Stack>
			</Box>
		</Stack>
	);
};

export default UnitSwitcher;
